import type { PayloadAction, CaseReducer } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import * as R from 'ramda';

type MemoizedValuesState = Record<string, any>;

type MemoizedValuesReducers = {
    set: CaseReducer<MemoizedValuesState, PayloadAction<{ key: string; value: any }>>;
    remove: CaseReducer<MemoizedValuesState, PayloadAction<string>>;
};

const initialState = {};

export const memoizedValuesSlice = createSlice<MemoizedValuesState, MemoizedValuesReducers, 'memoizedValues'>({
    name: 'memoizedValues',
    initialState,
    reducers: {
        set: (state, action) => {
            state[action.payload.key] = R.is(Object, action.payload.value)
                ? { ...state[action.payload.key], ...action.payload.value }
                : action.payload.value;
        },
        remove: (state, action) => {
            delete state[action.payload];
        },
    },
});

export const { set: setMemoizedValuesSlice, remove: removeMemoizedValuesSlice } = memoizedValuesSlice.actions;

export const memoizedValuesSelectors = {
    getMemoizedValues: (state: MemoizedValuesState) => state,
};
